import { GrantsType, hasScopedPermission } from '../../../Shared/utils/auth';

export const addVehiclePermissionsPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'vehicles.add');

export const removeVehiclePermissionsPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'vehicles.remove');

export const editVehiclePermissionsPolicy = (grants: GrantsType) =>
  editVehicleSafetyFeaturesPolicy(grants) ||
  editVehicleUseTypePolicy(grants) ||
  editVehicleMileagePolicy(grants) ||
  editVehicleLienholderPolicy(grants) ||
  editVehicleRidesharePolicy(grants) ||
  editVehicleOwnershipPolicy(grants);

export const editVehicleSafetyFeaturesPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'vehicles.edit_safety_features');
export const editVehicleUseTypePolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'vehicles.edit_use_type');
export const editVehicleMileagePolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'vehicles.edit_mileage');
export const editVehicleLienholderPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'vehicles.edit_lienholder');
export const editVehicleRidesharePolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'vehicles.edit_rideshare');
export const editVehicleOwnershipPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'vehicles.edit_ownership');
